import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_integration_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { INTEGRATIONS_KEY } from '@/utils/queryKeys.ts';

type DeleteIntegrationProps = {
  integrationId: string;
};

const useDeleteIntegration = (): UseMutationResult<void, AxiosError, DeleteIntegrationProps> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError, DeleteIntegrationProps>({
    mutationFn: async ({ integrationId }: DeleteIntegrationProps) => {
      await apiClient.delete(get_integration_url(integrationId));
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: INTEGRATIONS_KEY });
    },
  });
};

export default useDeleteIntegration;
